import CalculatorIcon from '../../../../../icons/calculator.svg?react';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import madeEasy from '../../../../../icons/madeEasy.svg?react';
import optionsTailored from '../../../../../icons/optionsTailored.svg?react';
import reviewPolicy from '../../../../../icons/reviewPolicy.svg?react';
import carrierApproval from '../../../../../icons/carrierApproval.svg?react';

export default function PurchasingProcessData() {
    return {
        title: "Our Purchasing Process",
        subtitle: "We represent the top rated, most competitively priced insurance companies to offer you the highest value coverage.",
        steps: [
            {
                title: "Determine Coverage Amount",
                icon: CalculatorIcon,
                paragraphs: [
                    "Use our easy calculation tool to determine the right amount of coverage to address your financial needs.",
                ]
            },
            {
                title: "Get a Personalized Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Enter some basic information and compare companies, products and prices from the industry's top insurance companies.",
                ]
            },
            {
                title: "Select and Apply",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "Select the carrier and coverage that fits your needs and start the application process.",
                ]
            },
            {
                title: "Receive Carrier Approval",
                icon: carrierApproval,
                paragraphs: [
                    " Receive updates on your application during the underwriting process. You will be notified when your application is approved.",
                ]
            },
            {
                title: "Review Policy and Activate Coverage",
                icon: reviewPolicy,
                paragraphs: [
                    "Once approved by the carrier, you will receive your policy for review and payment.",
                ]
            }
        ],
        stepsfooter:[
            {
                title: "Insurance coverage for everyone",
                icon: madeEasy,
                paragraphs: [
                    "From $50,000 to $10,000,000 and regardless of your health and personal background, we offer solutions to meet your unique circumstances.",
                ]
            },
            {
                title: "Life insurance tailored just for you",
                icon: optionsTailored,
                paragraphs: [
                    "We are here to provide personalized, concierge service to find you the right amount of coverage and appropriate term duration designed to fit your budget.",
                ]
            },
            
        ]
    };
}
